import { useState, useEffect, useRef, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';

import authAxios from "../../components/authAxios";

import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';


//ANT DESIGN
import { message, Upload } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import { Steps, Button, Radio } from 'antd';

import NumberFormat from "react-number-format";

import moment from 'moment';

import { UserContext } from "../../App";

import UserAlerts from "../../components/UserAlerts";

import '../rentals/Rentals.css'

function ResidentNew({isModalOpen, setIsModalOpen }) {
    const {page_size} = useContext(UserContext);

    const [error, setError] = useState('');
    const errorRef = useRef(null);
    const queryClient = useQueryClient();
    // const modalTitle = useRef("");

    const navigate = useNavigate();
    const [dt, setDt] = useState(null);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [id_type, setId_type] = useState('');
    const [id_number, setId_number] = useState('');
    const [type, setType] = useState('10');
    const [residentType, setResidentType] = useState('10');
    const [property, setProperty] = useState('');
    const [unit, setUnit] = useState('');
    const [country, setCountry] = useState('');

    const user = localStorage.getItem('userID');
    const client = localStorage.getItem('clientID');
    const [memo, setMemo] = useState('');

    const [nameError, setNameError] = useState(false)
    const [mobileError, setMobileError] = useState(false)
    const [idNumberError, setIdNumberError] = useState(false)

    const [isCompany, setIsCompany] = useState(false);
    const [isPerson, setIsPerson] = useState(false);

    const [startDate, setStartDate] = useState(null);
    

    const { data: countries } = useQuery({
        queryKey: ['countries'],
        queryFn: async () => {
          const response = await authAxios.get('/countries');
          return response.data
        },
    });

    const { data: properties } = useQuery({
        queryKey: ['properties'],
        queryFn: async () => {
            const response = await authAxios.get(`/rentals/properties/?page_size=${page_size}`);
        return response.data.results;
        },
    });

    const { data: units, refetch: refetchUnits } = useQuery({
        queryKey: ['units', property],
        queryFn: async () => {
            if (property) {
                const response = await authAxios.get(`/rentals/property-units/vacant?property=${property}`);
                return response.data;
            }
            return [];
        },
        enabled: !!property, // Fetch units only when property is selected
    });


    const { Step } = Steps;
    const [currentStep, setCurrentStep] = useState(0);

    const nextStep = () => {
      setCurrentStep(currentStep + 1);
    };
  
    const prevStep = () => {
      setCurrentStep(currentStep - 1);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const handleCustomerType = (e) => {
        setType(e.target.value)
        if (e.target.value===10){
            // console.log("TRUE")
            setIsPerson(true)
        }
        else {
            console.log("FALSE")
            setIsPerson(false)
        }
    }


    const handleIdNumber = (e) => {
        if (e.target.value.length>9){
            setIdNumberError(true)
        }
        else{
            setIdNumberError(false)
            setId_number(e.target.value)
        }
    }

    const mutation = useMutation({
        mutationFn: (contact) => {
            return authAxios.post('/contacts/', contact, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            });
        },
        onError: (error, variables, context) => {
            console.log("ERROR",error)
            if (error.response.data){
                const errorData = error.response.data;
                Object.keys(errorData).map((field, index) => (
                        <div key={index}> {/* Wrap content in a container (optional) */}
                            {
                            Array.isArray(errorData[field]) ? (
                                
                            <ul> {/* Use a list for arrays */}
                                {errorData[field].map((errorMessage) => (
                                <li key={index}> {/* Use the index as the key */}
                                    {setError(`${field}: ${errorMessage}`)}
                                </li>
                                ))}
                            </ul>
                            ) : (
                            <p>{setError(`${errorData[field]}`)}</p>
                            )}
                        </div>
                    ));
         
            } 
            else {
                // Fallback to Standard error message
                setError(error.message); 
            }      
        },
        onSuccess: (result) => {
            queryClient.invalidateQueries(['customers']);
            navigate('/dashboard/customers/');
            setIsModalOpen(false)
        },
      })


    const handleSubmit = (e) => {
        e.preventDefault();
        if (name === '') {
            setNameError(true)
        }

        if (mobile === '' ) {
            setMobileError(true)
        }

        if (name && mobile) {
            const category = "RESIDENT"
            const telephone = mobile.replace(/[()" "]/g,"")
            let start_date = null;
            if (dt){
                start_date = moment(dt).format("YYYY-MM-DD")
            }
            const resident_type = residentType
            const contact = {type, client, name, email, telephone, id_type, id_number, user, memo, unit, resident_type, category, start_date };
            console.log(contact)
            mutation.mutate(contact)
            
        } 
        else {
            setError("Missing name and/or mobile number"); 
        }
    }

    useEffect(()=>{
        if (error){
            errorRef.current.scrollIntoView();  
        }            
    },[error])   

    return(
        <div className="tenant-new">
        {isModalOpen && 
        <Modal 
            className="dashboard-modal" 
            // title={modalTitle.current}
            title="Add Resident"
            visible={isModalOpen} 
            open={isModalOpen} 
            onOk={handleSubmit} 
            onCancel={handleCancel} 
            footer={[
                currentStep > 0 &&
                    <Button type="default" key="prev" onClick={prevStep}>
                        Previous
                    </Button>
                ,
                currentStep < 2 && (
                    <Button type="primary" key="next" onClick={nextStep}>
                        Next
                    </Button>
                ),
                currentStep === 2 && (
                    <Button 
                        type="primary" 
                        key="save" 
                        htmlType="submit" 
                        onClick={handleSubmit}
                        // loading={isProcessing}
                        loading={mutation.isLoading} 
                    >
                        Save
                    </Button>
                )
                ]}
        >
            <div className="dashboard-form">

            <div ref={errorRef}>
                <UserAlerts error={error}  />
            </div>
            <Steps size="small" current={currentStep} >
                <Step title="Profile" />
                <Step title="Unit"  />
                <Step title="Documents"  />
            </Steps>

            <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                {currentStep === 0 && (
                <>

                <Radio.Group size="large" defaultValue={10} onChange={handleCustomerType} className="custom-input">
                    <Radio.Button  value={10}>Individual</Radio.Button>
                    <Radio.Button value={20}>Company</Radio.Button>
                </Radio.Group>

                <div>
                    <Radio.Group defaultValue={10} onChange={(e) => setResidentType(e.target.value)} className="custom-input">
                        <Radio value={10}>Tenant</Radio>
                        <Radio  value={20}>Owner</Radio>
                        <Radio  value={30}>Owner/Occupant</Radio>
                    </Radio.Group>
                </div>

                <TextField className="custom-input"
                    onChange={(e) => {
                        setNameError(false)
                        setName(e.target.value)
                    }}
                    label="Name" 
                    variant="outlined" 
                    fullWidth
                    required
                    error={nameError}
                />

                <NumberFormat 
                    onChange={(e) => {
                        setMobileError(false)
                        setMobile(e.target.value)
                    }}
                    className="custom-input"
                    fullWidth
                    label="Telephone" 
                    variant="outlined" 
                    customInput={TextField}
                    format="### (###) ######" mask="_"
                    required
                    error={mobileError}
                />

                <TextField className="custom-input"
                    onChange={(e) => {
                        setEmail(e.target.value)
                    }}
                    label="Email" 
                    variant="outlined" 
                    fullWidth
                />

                </>
                )}

                {currentStep === 1 && (
                <> 
                    <Autocomplete
                        onChange={(event, newValue) => {
                            setProperty(newValue.id);
                        }}
                        options={properties || []}
                        getOptionLabel={(option) => { return option ? option.name : '' }} // Ensure option is not null or undefined
                        renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Property" />}
                    />

                    <Autocomplete
                        // onChange={(event, newValue) => handleUnitSelection(newValue)}
                        onChange={(event, newValue) => {
                            setUnit(newValue.id)
                        }}
                        options={units || []}
                        getOptionLabel={(option) => {
                            return option ? option.reference : ''; // Ensure option is not null or undefined
                        }}
                        renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Unit" />}
                        disabled={!property} // Disable unit selection until property is selected
                    />

                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DesktopDatePicker
                            label="Occupancy Start Date"
                            value={dt}
                            onChange={(newDate) => {
                                setDt(moment(newDate).format("YYYY-MM-DD"));
                            }}
                            renderInput={(params) => <TextField fullWidth required className="custom-input" {...params} />}
                        />
                    </LocalizationProvider>
                </>
                )}

                
                {currentStep === 2 && (
                <> 
                    
                    <Autocomplete
                        onChange={(event, newValue) => {
                            setCountry(newValue.id);
                            console.log("VALUE", newValue.id)
                            }}
                        options={countries}
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Nationality"  /> }
                    /> 


                    <Radio.Group
                        onChange={(e) => setId_type(e.target.value)}
                        className="custom-input"
                    >
                        <Radio value={10}>Citizen ID</Radio>
                        <Radio value={20}>Passport</Radio>
                    </Radio.Group>

                    <TextField className="custom-input"
                        onChange={handleIdNumber}
                        label="ID/Passport Number" 
                        helperText="Maximum number of characters is 9" 
                        variant="outlined" 
                        fullWidth
                        required
                        error={idNumberError}
                    /> 

                    </>
                )}

            </form>
        </div>
        </Modal>
        }

        </div>


    )

}

export default ResidentNew;
